import { ReactComponent as BlocksIcon } from "../../assets/cases/autumn-2026/blocks.svg";
import { ReactComponent as BookOpenIcon } from "../../assets/cases/autumn-2026/book-open.svg";
import { ReactComponent as BotIcon } from "../../assets/cases/autumn-2026/bot.svg";
import { ReactComponent as BrainIcon } from "../../assets/cases/autumn-2026/brain.svg";
import { ReactComponent as BriefcaseBusinessIcon } from "../../assets/cases/autumn-2026/briefcase-business.svg";
import { ReactComponent as CalculatorIcon } from "../../assets/cases/autumn-2026/calculator.svg";
import { ReactComponent as ChartCandlestickIcon } from "../../assets/cases/autumn-2026/chart-candlestick.svg";
import { ReactComponent as ChartGanttIcon } from "../../assets/cases/autumn-2026/chart-gantt.svg";
import { ReactComponent as ChessKnightIcon } from "../../assets/cases/autumn-2026/chess-knight.svg";
import { ReactComponent as CircuitBoardIcon } from "../../assets/cases/autumn-2026/circuit-board.svg";
import { ReactComponent as CloudLightningIcon } from "../../assets/cases/autumn-2026/cloud-lightning.svg";
import { ReactComponent as CompassIcon } from "../../assets/cases/autumn-2026/compass.svg";
import { ReactComponent as CupSodaIcon } from "../../assets/cases/autumn-2026/cup-soda.svg";
import { ReactComponent as DroneIcon } from "../../assets/cases/autumn-2026/drone.svg";
import { ReactComponent as GraduationCapIcon } from "../../assets/cases/autumn-2026/graduation-cap.svg";
import { ReactComponent as HandIcon } from "../../assets/cases/autumn-2026/hand.svg";
import { ReactComponent as LanguagesIcon } from "../../assets/cases/autumn-2026/languages.svg";
import { ReactComponent as PrinterIcon } from "../../assets/cases/autumn-2026/printer.svg";
import { ReactComponent as RouteIcon } from "../../assets/cases/autumn-2026/route.svg";
import { ReactComponent as ScaleIcon } from "../../assets/cases/autumn-2026/scale.svg";
import { ReactComponent as ShieldCheckIcon } from "../../assets/cases/autumn-2026/shield-check.svg";
import { ReactComponent as SmartphoneIcon } from "../../assets/cases/autumn-2026/smartphone.svg";
import { ReactComponent as SproutIcon } from "../../assets/cases/autumn-2026/sprout.svg";
import { ReactComponent as StethoscopeIcon } from "../../assets/cases/autumn-2026/stethoscope.svg";
import { ReactComponent as TimerIcon } from "../../assets/cases/autumn-2026/timer.svg";
import { ReactComponent as UsersRoundIcon } from "../../assets/cases/autumn-2026/users-round.svg";
import armetLogo from "../../assets/cases/autumn-2026/armet.svg";
import centrinvestLogo from "../../assets/cases/autumn-2026/centrinvest.svg";
import ecoindLogo from "../../assets/cases/autumn-2026/ecoind.png";
import gazprombankLogo from "../../assets/cases/autumn-2026/gazprombank.png";
import neurotechLogo from "../../assets/cases/autumn-2026/neurotech.png";
import rostelecomLogo from "../../assets/cases/autumn-2026/rostelecom.svg";
import school96Logo from "../../assets/cases/autumn-2026/school96.png";
import stupeniLogo from "../../assets/cases/autumn-2026/stupeni.png";
import x5Logo from "../../assets/cases/autumn-2026/x5.svg";

// Curated for the published autumn cases. Sources and licensing are recorded in
// src/assets/cases/autumn-2026/sources.json and public/licenses/lucide.txt.
// Project codes survive a reimport; the season slug prevents matches in archives.
const autumnArtwork = {
  "П1": { src: gazprombankLogo, asset: "gazprombank" },
  "П2": { src: centrinvestLogo, asset: "centrinvest" },
  "П3": { Icon: RouteIcon, tone: "teal", asset: "route" },
  "П4": { Icon: CompassIcon, tone: "green", asset: "compass" },
  "П5": { src: neurotechLogo, asset: "neurotech" },
  "П6": { src: neurotechLogo, asset: "neurotech" },
  "П7": { src: stupeniLogo, asset: "stupeni" },
  "П8": { Icon: BlocksIcon, tone: "amber", asset: "blocks" },
  "П9": { src: armetLogo, asset: "armet" },
  "П10": { src: school96Logo, asset: "school96" },
  "П11": { Icon: ChessKnightIcon, tone: "violet", asset: "chess-knight" },
  "П12": { Icon: BookOpenIcon, tone: "rose", asset: "book-open" },
  "П13": { Icon: UsersRoundIcon, tone: "amber", asset: "users-round" },
  "П14": { Icon: ShieldCheckIcon, tone: "blue", asset: "shield-check" },
  "П15": { src: ecoindLogo, asset: "ecoind" },
  "П16": { src: rostelecomLogo, asset: "rostelecom" },
  "П17": { src: x5Logo, asset: "x5" },
  "И1": { Icon: CloudLightningIcon, tone: "blue", asset: "cloud-lightning" },
  "И2": { Icon: BotIcon, tone: "violet", asset: "bot" },
  "И3": { Icon: HandIcon, tone: "rose", asset: "hand" },
  "И4": { Icon: DroneIcon, tone: "green", asset: "drone" },
  "И5": { Icon: TimerIcon, tone: "amber", asset: "timer" },
  "И6": { Icon: BrainIcon, tone: "violet", asset: "brain" },
  "С1": { Icon: LanguagesIcon, tone: "amber", asset: "languages" },
  "С2": { Icon: PrinterIcon, tone: "blue", asset: "printer" },
  "С3": { Icon: CircuitBoardIcon, tone: "violet", asset: "circuit-board" },
  "С4": { Icon: ChartCandlestickIcon, tone: "green", asset: "chart-candlestick" },
  "С5": { Icon: ScaleIcon, tone: "blue", asset: "scale" },
  "С6": { Icon: StethoscopeIcon, tone: "teal", asset: "stethoscope" },
  "С7": { Icon: ChartGanttIcon, tone: "violet", asset: "chart-gantt" },
  "С8": { Icon: GraduationCapIcon, tone: "blue", asset: "graduation-cap" },
  "С9": { Icon: SmartphoneIcon, tone: "blue", asset: "smartphone" },
  "С10": { Icon: CupSodaIcon, tone: "amber", asset: "cup-soda" },
  "С11": { Icon: SproutIcon, tone: "green", asset: "sprout" },
  "С12": { Icon: CalculatorIcon, tone: "violet", asset: "calculator" },
  "С13": { Icon: BriefcaseBusinessIcon, tone: "teal", asset: "briefcase-business" },
};

export function getCaseArtwork(caseItem, season) {
  if (season?.slug !== "autumn-2026") return null;
  const code = String(caseItem?.project_code || "").trim().toUpperCase();
  return Object.hasOwn(autumnArtwork, code) ? autumnArtwork[code] : null;
}
